function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#2D3844"
}, React.createElement("path", {
  fill: "#2D3844",
  strokeWidth: 2,
  d: "M3,3 L3,74 L67,74 L67,14.0877144 L56.1561803,3 L3,3 Z"
}), React.createElement("path", {
  fill: "#FFF",
  strokeWidth: 2,
  d: "M1,1 L1,72 L65,72 L65,12.0877144 L54.1561803,1 L1,1 Z"
}), React.createElement("polygon", {
  fill: "#2D3844",
  points: "54 2 65 12 54 12"
}), React.createElement("path", {
  strokeWidth: 2,
  d: "M13 24.5L53 24.5M13 36.5L53 36.5M13 48.5L33 48.5"
}));

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 68,
    height: 75,
    viewBox: "0 0 68 75",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.2dda6684.svg";
export { ForwardRef as ReactComponent };